import { _dtImageTrans } from './__inner/image/_dtImageTrans';

/**
 * @description 将被裁剪或缩放的图片还原成原图
 * @param url 图片地址
 * @param suffixTrim 是否将静态图还原成gif（原图是gif）
 * @returns
 */
const dtImageOrigin = (url: string, suffixTrim: boolean): string => {
  let ret = _dtImageTrans(url);
  if (suffixTrim) {
    ret = ret.replace(/(_webp|_jpeg)$/, '');
  }
  return ret;
};
export default dtImageOrigin;
